import React, { Component } from 'react';
import PubSub from 'pubsub-js';

let DATA = {};

const withData = (WrappedComponent, listeners, triggers) => {
  return class DataStore extends Component {

    constructor(props) {
      super(props);
      this.state = {data:DATA};
  
    }

  componentDidMount() {

      const _this = this;
      PubSub.subscribe( 'store', (label,data) => {
         
          _this.setState({data:DATA});

      });

  }

  store = (label,item,publish=true) => {
      
      //console.log('store',label,'publish',publish);
      DATA = {...DATA};
      DATA[label] = item;
      this.setState({data:DATA});

      if(publish) this.publish();
  }

  publish = () => {

      PubSub.publish('store',DATA);

  }

  get = (label,data) => {
  	 
      if(DATA.hasOwnProperty(label)) return DATA[label];

  }


  componentWillUnmount() {



    }


    render() {

      return (
        <WrappedComponent ref="WrappedComponent" datastore={this} data={{...this.state.data}} { ...this.props } />
      );
    }
  }
}

export default withData;


// WEBPACK FOOTER //
// ./src/js/utils/withData.js